/*
 * @Author: ChengQing
 * @Date: 2020-10-09 09:53:54
 * @Last Modified by: ChengQing
 * @Last Modified time: 2020-10-09 09:57:51
 */
import React, { useState, useEffect, useRef } from "react";
import { Layout, Dropdown, Menu, Select, Spin, message } from "antd";
import {
  DownOutlined,
} from '@ant-design/icons';
import { connect } from "react-redux";
import MyIcon from "../MyIcon";
import "./index.scss";
import Modal from "antd/lib/modal/Modal";
import { forecastApi } from "@api/newApi";
import code from "./code.png";
import icon_user_SVIP from './img/icon_user_SVIP.png'
import icon_user_VIP from './img/icon_user_VIP.png'
import icon_user_low from './img/icon_user_low.png'
import aiNormalImg from '../../assets/ai-icon-normal.png';
import aiNormalShield from '../../assets/ai-shield-normal.png';
import aiWarnImg from '../../assets/ai-icon-warn.png';
import aiWarnShield from '../../assets/ai-shield-warn.png';
import aiHeadImg from '../../assets/ai-head-img.png';
import aiBg from '../../assets/ai-bg.png';
import meterScale from '../../assets/meter-scale.png';
import whiteRightIcon from '../../assets/white-right.png';
import lljImg from '../../assets/icon-llj.png';
import ywyImg from '../../assets/icon-ywy.png';
import * as echarts from "echarts";
const { Header } = Layout;
import classnames from 'classnames';
import { logout } from '../../store/actions/common';
import Icom from "../../assets/logoicon.png";

let djMyCharts = null;
let trendMyEcharts = null;

const Pages = ({ userInfo, showLogout, collapsed, history, dispatch }) => {
  const [visible, setVisible] = useState(false);
  const roleLevel = JSON.parse(sessionStorage.getItem('userInfo')).roleLevel
  const loadCode = () => {
    setVisible(true);
  };

  const oncancel = () => {
    setVisible(false);
  };

  // 退出登录
  const loginOutFn = (value) => {
    // if (value.key === "tmp_key-0") {
    // console.log(key)
    // dispatch(logout({ id: userInfo.id }));
    history.push('/login')
    // }
  };

  const menuItems = [
    { label: <a href="javascript:;" onClick={loginOutFn}>退出登录</a>, key: 'item-1' },
  ]

  // 是否展示ai弹窗
  const [showAiModal, setshowAiModal] = useState(false);
  // 是否展示风险列表页
  const [showListPage, setshowListPage] = useState(true);

  // ai分页列表的查询条件
  const [aiListParams, setaiListParams] = useState({
    forecastGrade: 3, // 预警等级(null-全部，1-低 3-高)
    monitorType: 1, // 监控事件(1-泵堵)
    type: 2,
    pageNum: 1,
    pageSize: 100000,
  });
  // ai列表数据
  const [aiListData, setaiListData] = useState([]);
  // ai预警总数
  const [aiListTotal, setaiListTotal] = useState(0);

  // 获取ai分页列表
  const getAiList = (data) => {
    forecastApi.selectForecastByPage({ ...data })
      .then((res) => {
        if (res.status * 1 === 0) {
          setaiListData(res.data.data);
          setaiListTotal(res.data.total * 1)
        }
      })
  }
  useEffect(() => {
    getAiList(aiListParams)
  }, [aiListParams]);

  // 是否展示风险详情页
  const [showDetailPage, setshowDetailPage] = useState(false);
  // 风险等级百分比
  const [rateVal, setrateVal] = useState(0);
  // 风险详情数据
  const [aiDetailData, setaiDetailData] = useState({
    forecastPvPOs: [],
    processunitS: []
  });

  // 获取百分比定位的位置
  const getPosition = (rate) => {
    let position = {
      bottom: '10%',
      left: '76%',
    }
    if (rate == 0) {
      position = {
        bottom: '10%',
        left: '14%',
      }
    } else if (rate < 11) {
      position = {
        bottom: '22%',
        left: '10%',
      }
    } else if (rate < 21) {
      position = {
        bottom: '40%',
        left: '9%',
      }
    } else if (rate < 31) {
      position = {
        bottom: '53%',
        left: '11%',
      }
    } else if (rate < 41) {
      position = {
        bottom: '64%',
        left: '12.5%',
      }
    } else if (rate < 51) {
      position = {
        bottom: '86%',
        left: '42%',
      }
    } else if (rate < 61) {
      position = {
        bottom: '80%',
        left: '69%',
      }
    } else if (rate < 71) {
      position = {
        bottom: '66%',
        left: '74%',
      }
    } else if (rate < 81) {
      position = {
        bottom: '52%',
        left: '77%',
      }
    } else if (rate < 91) {
      position = {
        bottom: '32%',
        left: '77%',
      }
    } else {
      position = {
        bottom: '10%',
        left: '76%',
      }
    }
    return position;
  }

  // 风险等级图dom
  const djEchartsRef = useRef(null);
  // 风险等级仪表展示
  const showBar = (echart, rate) => {
    if (djMyCharts) {
      djMyCharts.dispose();
    }
    djMyCharts = echarts.init(djEchartsRef.current);
    let int = (rate < 30 || rate == 30) ? '低' : rate > 70 ? '高' : '中';
    let title = '风险等级';
    let value = rate;
    let position = getPosition(rate);

    let option = {
      animationDuration: 3000,
      backgroundColor: 'transparent',
      title: [{
        text: value + '%',
        x: 'center',
        ...position,
        textStyle: {
          color: int == '高' ? '#D74E32' : int == '中' ? '#F68624' : '#80CD30',
          fontSize: 14,
          fontWeight: '100',
          lineHeight: 1
        },
        backgroundColor: '#fff',
        borderRadius: 5,
        padding: [12, 8, 8, 8],
      }, {
        text: '{a|' + int + '}\n{b|' + title + '}',
        x: 'center',
        y: '35%',
        textStyle: {
          rich: {
            a: {
              fontSize: 40,
              color: '#fff',
              lineHeight: 50,
              fontWeight: 'normal'
            },
            b: {
              fontSize: 16,
              color: '#fff',
              lineHeight: 20
            },
          }
        }
      }],
      angleAxis: {
        show: false,
        max: 100 * 360 / 250,
        type: 'value',
        startAngle: 215, //极坐标初始角度
        splitLine: {
          show: false
        }
      },
      barMaxWidth: 8, //圆环宽度
      radiusAxis: {
        show: false,
        type: 'category',
      },
      //圆环位置和大小
      polar: {
        center: ['50%', '60%'],
        radius: '120'
      },
      series: [{
        type: 'bar',
        data: [{ //上层圆环，显示数据
          value: value,
          itemStyle: {
            color: '#fff',
          },
        }],
        barGap: '-100%', //柱间距离,上下两层圆环重合
        coordinateSystem: 'polar',
        roundCap: true, //顶端圆角从 v4.5.0 开始支持
        z: 2 //圆环层级，同zindex
      },
      { //下层圆环，显示最大值
        type: 'bar',
        data: [{
          value: 100,
          itemStyle: {
            color: '#fff',
            opacity: 0.2
          }
        }],
        barGap: '-100%',
        coordinateSystem: 'polar',
        roundCap: true,
        z: 1
      },
      ]
    };

    // 绘制图表
    djMyCharts.setOption(option);
  }

  // 风险趋势图dom
  const trendEchartsRef = useRef(null)
  // 风险趋势图
  const showTrendEcharts = (data, echart) => {
    if (trendMyEcharts) {
      trendMyEcharts.dispose();
    }
    trendMyEcharts = echarts.init(trendEchartsRef.current);
    let xData = [];
    let fxData = []; //风险数据
    let ywData = []; //液位数据
    let llData = []; //流量数据
    data.map((mm) => {
      xData.push(mm.dataTime.substr(11, 5));
      fxData.push((mm.dataValue * 100).toFixed(0));
      ywData.push(mm.forecastParam['液位计']);
      llData.push(mm.forecastParam['流量计']);
    })

    let option = {
      tooltip: {
        trigger: "axis",
        padding: [5, 0, 0, 0],
        backgroundColor: 'transparent',
        confine: true, // 是否将 tooltip 框限制在图表的区域内
        formatter: function (params) {
          var result = `<div class='line-tooltip-box' style='padding:8px 10px;font-size:12px;box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);'>`;
          let dw = '';
          params.map((item, idx) => {
            if (idx != 0) {
              dw = `%(${item.data > 70 ? '高' : (item.data != 0 && (item.data < 30 || item.data == 30) ? '低' : '中')})`;
              result += `<div key='${idx}}' style="color:#5A5F64;display:flex;justify-content: space-between;align-items: center;">
                <span style="margin-right:15px;">${item.seriesName}</span>
                <span style="color:${idx != 1 ? '#2D99FF' : '#FFAE28'};">${item.value + (idx == 1 ? dw : '')}</span>
              </div>`
            } else {
              result += `<div style="color:#5A5F64;">${item.name}</div>`
            }
          })
          result += '</div>'
          return result;
        }
      },
      grid: {
        left: '4%',
        top: '15px',
        bottom: 0,
        right: '2%',
        containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,  //想要不显示网格线，改为false
          lineStyle: {
            color: ['#EEF0F3'],
            width: 1,
            type: 'solid'
          }
        },
        axisLine: {
          lineStyle: {
            width: "0", //坐标线的宽度
          },
        },
        axisLabel: {
          // interval:0,
          color: "#5A5F64", //坐标值得具体的颜色
          fontSize: "12",
          textAlign: "center",
        },
      },
      yAxis: {
        type: 'value',
        splitNumber: 5,
        max: 100,
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,  //想要不显示网格线，改为false
          lineStyle: {
            color: ['#EEF0F3'],
            width: 1,
            type: 'solid'
          }
        },
        axisLine: {
          lineStyle: {
            width: "0", //坐标线的宽度
          },
        },
        axisLabel: {
          color: "#5A5F64", //坐标值得具体的颜色
          fontSize: "12",
        },
      },
      series: [{
        name: '',
        data: fxData,
        type: 'line',
        itemStyle: {
          color: '#FFAE28', //折点颜色
          lineStyle: {
            color: '#FFAE28' //折线颜色
          },
        }
      }, {
        name: '风险值',
        type: 'line',
        symbolSize: 0,
        showSymbol: false,
        lineStyle: {
          width: 0,
          color: 'transparent'
        },
        data: fxData,
      }, {
        name: '液位计',
        type: 'line',
        symbolSize: 0,
        showSymbol: false,
        lineStyle: {
          width: 0,
          color: 'transparent'
        },
        data: ywData,
      }, {
        name: '流量计',
        type: 'line',
        symbolSize: 0,
        showSymbol: false,
        lineStyle: {
          width: 0,
          color: 'transparent'
        },
        data: llData,
      }]
    };

    // 绘制图表
    trendMyEcharts.setOption(option);
  }

  // 关闭ai告警弹窗
  const closeAiModal = () => {
    setshowAiModal(false);
    setshowListPage(true);
    setshowDetailPage(false);
    aiTimer && clearInterval(aiTimer);
    setaiTimer(null);
  }
  // ai告警详情loading
  const [aiDetailLoading, setaiDetailLoading] = useState(false);
  // ai详情timer
  const [aiTimer, setaiTimer] = useState(null);
  // 获取ai预警详情
  const getAiDetailFn = (item) => {
    let data = {
      forecastId: item.id,
      monitorType: item.monitorType,
      stationId: item.stationId
    };
    forecastApi.selectForecastInfo(data)
      .then((res) => {
        setaiDetailLoading(false);
        if (res.status * 1 === 0) {
          let rate = (res.data.forecastPvPOs[res.data.forecastPvPOs.length - 1].dataValue * 100).toFixed(2);
          setrateVal(rate);
          setaiDetailData(res.data);
          showBar('djEcharts', rate);
          showTrendEcharts(res.data.forecastPvPOs, 'trendEcharts');
        }
      })
  }

  // 立即处理按钮
  const handleBtn = () => {
    let data = {
      forecastId: aiDevice.id,
    };
    forecastApi.promptlyHandle(data)
      .then((res) => {
        if (res.status * 1 === 0) {
          message.success("操作成功！")
        }
      })
  }

  // 选中预警设备
  const [aiDevice, setaiDevice] = useState({});
  // 展示设备ai预警详情页
  const showDetailPageFn = (item) => {
    setaiDetailLoading(true);
    setshowListPage(false);
    setshowDetailPage(true);
    setaiDevice(item)
    getAiDetailFn(item);
    setaiTimer(setInterval(() => {
      getAiDetailFn(item);
    }, 5000))
  }

  return (
    <Header
      className="header-box"
      style={collapsed ? { width: "calc(100% - 80px)" } : null}
    >
      <div className="header-box-logo"></div>
      <ul className="header-left-menu">
        <li
          className="header-left-menu-item"
          style={{ margin: "0 27px 0 24px" }}
        >
          <a className="whiteColor menu-item-link">
            <MyIcon
              type="icon-gaojingzhongxin"
              style={{ fontSize: "16px", color: "#5A5F64" }}
            />
          </a>
        </li>
        <li className="header-left-menu-item">
          <div className="imgs-user">
            {
              roleLevel == 0 ? <img src={icon_user_SVIP} /> : roleLevel == 1 ? <img src={icon_user_VIP} /> : <img src={icon_user_low} />
            }

          </div>
          <Dropdown menu={{ items: menuItems }}>
            <a onClick={(e) => e.preventDefault()} className="ant-dropdown-link">
              <span style={{ marginRight: "9px" }}>{userInfo && (userInfo.realName || userInfo.name)}</span>
              <DownOutlined />
            </a>
          </Dropdown>

          {/* <a
            className="whiteColor menu-item-link"
            onClick={() => showLogout && showLogout()}
          >
            <MyIcon
              type="icon-export"
              style={{ fontSize: "20px", paddingRight: "5px" }}
            />
          </a> */}
        </li>
        <li className="header-ai-box header-left-menu-item">
          <div className="ai-icon"
            onClick={() => {
              if (!showDetailPage) {
                setshowAiModal(true);
                setrateVal(0);
              }
            }}>
            <div className="rotate">
              <img src={aiListTotal == 0 ? aiNormalImg : aiWarnImg} />
            </div>
            <img className="shield-img" src={aiListTotal == 0 ? aiNormalShield : aiWarnShield} />
          </div>
          {showAiModal && <div className="ai-area-wrap">
            <div className={classnames({
              'top-arrow': true,
              danger: rateVal > 70,
              normal: rateVal != 0 && (rateVal < 30 || rateVal == 30),
              warn: rateVal > 30 && (rateVal < 70 || rateVal == 70),
            })}></div>
            {/* 风险列表页 */}
            {showListPage && <div className="one-page">
              <div className="head-info">
                <img className="rotate-img" src={aiHeadImg} />
                <i className="close-btn iconfont iconguanbi"
                  onClick={() => closeAiModal()}></i>
                <h3>预警设备总数</h3>
                <p><strong>{aiListTotal}</strong>台</p>
                <img className="bg-img" src={aiBg} />
              </div>
              <div className="con-info">
                <div className="condi-area">
                  监控事件：
                  <Select bordered={false}
                    className="ai-condi-select"
                    onChange={(val) => {
                      setaiListParams({
                        ...aiListParams,
                        monitorType: val,
                      })
                    }}
                    defaultValue={1}>
                    <Select.Option value={1}>泵堵</Select.Option>
                  </Select>
                  排序方式：
                  <Select bordered={false}
                    style={{ width: '85px', marginRight: 0 }}
                    onChange={(val) => {
                      setaiListParams({
                        ...aiListParams,
                        forecastGrade: val,
                      })
                    }}
                    className="ai-condi-select"
                    defaultValue={3}>
                    <Select.Option value={3}>由高到低</Select.Option>
                    <Select.Option value={1}>由低到高</Select.Option>
                  </Select>
                </div>
                <div className="item-box">
                  {aiListData.length == 0 && <div className="no-data">- 暂无数据 -</div>}
                  {aiListData.map((item, idx) => {
                    return (
                      <div className="item"
                        key={idx}
                        onClick={() => showDetailPageFn(item)}>
                        <h6>{item.forecastInfo}</h6>
                        <div className="station-info">
                          <i className="iconfont iconicon_nav_changzhanguanli_act"></i>
                          {item.stationName}
                        </div>
                        <div className={
                          classnames({
                            'status-box': true,
                            danger: item.forecastGrade == 3,
                            warn: item.forecastGrade == 2,
                            normal: item.forecastGrade == 1
                          })
                        }>
                          <strong>{item.forecastGrade == 3 ? '高' : item.forecastGrade == 1 ? '低' : '中'}</strong>
                          <p>风险等级</p>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>}
            {/* 风险详情页 */}
            {showDetailPage && <div className="two-page">
              <Spin spinning={aiDetailLoading} tip="加载中,请稍等...">
                <div className={classnames({
                  'head-animate-box': true,
                  danger: rateVal > 70,
                  normal: rateVal != 0 && (rateVal < 30 || rateVal == 30),
                  warn: rateVal > 30 && (rateVal < 70 || rateVal == 70),
                })}>
                  <div className="tit">
                    <img src={whiteRightIcon}
                      onClick={() => {
                        getAiList(aiListParams);
                        setshowListPage(true);
                        setshowDetailPage(false);
                        setrateVal(0);
                        aiTimer && clearInterval(aiTimer);
                        setaiTimer(null);
                      }} />
                    <b>{aiDevice.stationName}{aiDevice.forecastInfo}</b>
                    <i className="iconfont iconguanbi"
                      onClick={() => closeAiModal()}></i>
                  </div>
                  <div className="con">
                    <img className="meter-scale-img" src={meterScale} />
                    <div id="djEcharts" ref={djEchartsRef} style={{ height: '152px' }}></div>
                  </div>
                </div>
                <div className="two-page-body">
                  <div className="tit">
                    <strong>风险趋势</strong>
                    <i>最近24小时数据</i>
                  </div>
                  <div style={{ height: '130px', overflow: 'hidden' }}>
                    <div id="trendEcharts" ref={trendEchartsRef} style={{ height: '130px' }}></div>
                  </div>
                  <div className="info-item-box">
                    {
                      aiDetailData.processunitS && aiDetailData.processunitS.map((item, index) => {
                        return (
                          <div className="info-item" key={index}>
                            <img className="icon" src={item.deviceName == '流量计' ? lljImg : ywyImg} />
                            <div className="flex1">
                              <p>{item.deviceName}</p>
                              <div>
                                <i className="iconfont iconicon_gongyidanyuan_tiaojiechi_32"></i>
                                {item.processunitName}
                              </div>
                            </div>
                            <span className="val">{item.val + item.unit}</span>
                          </div>
                        )
                      })
                    }
                  </div>
                  <div className="handle-btn"
                    onClick={() => handleBtn()}>
                    立即处理
                  </div>
                </div>
              </Spin>
            </div>}
          </div>}
        </li>
      </ul>
      <Modal
        title="扫码下载App"
        open={visible}
        onCancel={oncancel}
        footer={false}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={code} alt="" />
        </div>
      </Modal>
    </Header>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
